module.exports = __webpack_public_path__ + "img/varoszoba_onarckep_2.bffaca29.jpg";